import { useEffect, useRef } from "react";
import { authClient, useAuth } from "../AuthContext";

/**
 * Gestisce #session_id=... legacy (OAuth dismesso) senza bloccare la pagina.
 * Rimuove subito l'hash dall'URL e completa il login in background.
 */
export default function OAuthHashHandler() {
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) return;
    done.current = true;

    const sessionId = decodeURIComponent(m[1]);
    const path = window.location.pathname + window.location.search;
    window.history.replaceState({}, document.title, path || "/");

    (async () => {
      try {
        const r = await authClient.post("/auth/session", { session_id: sessionId }, { timeout: 12000 });
        setUser(r.data?.user || null);
      } catch (e) {
        console.warn("OAuth session exchange skipped:", e?.message || e);
      }
    })();
  }, [setUser]);

  return null;
}
